const STEP_SEND_SMS = 'step-send-sms'
const STEP_CHECK_SMS = 'step-check-sms'
const STEP_LOAN_INFO = 'step-loan-info'
const STEP_PAYMENT_PAGE = 'step-payment-page'
const STEP_PAYMENT_BY_TOKEN = 'step-payment-by-token'

const FETCH_SEND_SMS_PAGE = 'FETCH_SEND_SMS_PAGE'
const FETCH_CHECK_SMS_PAGE = 'FETCH_CHECK_SMS_PAGE'
const FETCH_SET_ACCESS_TOKEN = 'FETCH_SET_ACCESS_TOKEN'
const FETCH_PAYMENT_BY_TOKEN_PAGE = 'FETCH_PAYMENT_BY_TOKEN_PAGE'
const FETCH_LOAN_INFO_PAGE = 'FETCH_LOAN_INFO_PAGE'
const FETCH_PAYMENT_PAGE = 'FETCH_PAYMENT_PAGE'

const sendSmsPage = () => {
    return {
        type: FETCH_SEND_SMS_PAGE
    }
}

const checkSmsPage = () => {
    return {
        type: FETCH_CHECK_SMS_PAGE
    }
}

const loanInfoPage = () => {
    return {
        type: FETCH_LOAN_INFO_PAGE
    }
}

const paymentPage = () => {
    return {
        type: FETCH_PAYMENT_PAGE
    }
}

const paymentByTokenPage = ({accessToken, backUrl}) => {
    return {
        type: FETCH_PAYMENT_BY_TOKEN_PAGE,
        payload: {
            accessToken,
            backUrl
        }
    }
}

const setAccessToken = ({accessToken}) => {
    return {
        type: FETCH_SET_ACCESS_TOKEN,
        payload: accessToken
    }
}

const fetchSendSmsPage = (dispatch) => () => {
    dispatch(sendSmsPage())
}

const fetchCheckSmsPage = (dispatch) => () => {
    dispatch(checkSmsPage())
}

const fetchLoanInfoPage = (dispatch) => () => {
    dispatch(loanInfoPage())
}

const fetchPaymentPage = (dispatch) => () => {
    dispatch(paymentPage())
}

const fetchPaymentByTokenPage = (dispatch) => ({accessToken, backUrl}) => {
    dispatch(paymentByTokenPage({accessToken, backUrl}))
}

const fetchSetAccessToken = (dispatch) => ({accessToken}) => {
    dispatch(setAccessToken({accessToken}))
}

export {
    FETCH_SEND_SMS_PAGE,
    FETCH_CHECK_SMS_PAGE,
    FETCH_PAYMENT_BY_TOKEN_PAGE,
    FETCH_LOAN_INFO_PAGE,
    FETCH_SET_ACCESS_TOKEN,
    FETCH_PAYMENT_PAGE,
    fetchSetAccessToken,
    fetchSendSmsPage,
    fetchCheckSmsPage,
    fetchLoanInfoPage,
    fetchPaymentByTokenPage,
    fetchPaymentPage,
    STEP_SEND_SMS,
    STEP_CHECK_SMS,
    STEP_LOAN_INFO,
    STEP_PAYMENT_BY_TOKEN,
    STEP_PAYMENT_PAGE,
}